import type React from "react"
import { memo, useCallback } from "react"
import { Link } from "react-router-dom"
import { twMerge } from "tailwind-merge"
import type { ButtonProps } from "../common/types"

type BottomBarDesktopProps = {
  onNext?: (() => void) | string
  onBack?: (() => void) | string
  labelNext?: string
  labelBack?: string
  message?: string
  showActions?: boolean
  insideCard?: boolean
  insideModal?: boolean
  disableNext?: boolean
  disableBack?: boolean
  variantPrimary?: ButtonProps["variant"]
  variantSecondary?: ButtonProps["variant"]
}

const BottomBarDesktop: React.FC<BottomBarDesktopProps> = ({
  onNext,
  onBack,
  labelBack,
  labelNext,
  message,
  showActions = true,
  insideCard,
  insideModal,
  disableNext,
  disableBack,
  variantPrimary = "primary",
  variantSecondary = "secondary",
}) => {
  const variantPrimaryClasses = {
    primary: "btn-primary-sm !py-[11.5px]",
    alert: "btn-alert-sm !py-[11.5px]",
    secondary: "btn-secondary-sm !py-[11.5px]",
  }

  const variantSecondaryClasses = {
    primary: "btn-primary-sm !py-[11.5px]",
    alert: "btn-alert-sm !py-[11.5px]",
    secondary: "btn-secondary-sm !py-[11.5px]",
  }

  const handleBack = useCallback(() => {
    if (typeof onBack === "function") {
      onBack()
    }
  }, [onBack])

  const handleNext = useCallback(() => {
    if (typeof onNext === "function") {
      onNext()
    }
  }, [onNext])

  return (
    <div
      className={twMerge(
        message && showActions ? "justify-between" : message ? "justify-start" : "justify-end",
        insideCard && "pt-2 pb-6 px-8",
        insideModal && "pt-2 pb-0 px-0",
        "flex items-center gap-x-2",
      )}
    >
      {message && <span className="text-pn-callout-regular text-pn_gray-600">{message}</span>}
      {showActions && (
        <div className="flex items-center gap-x-4">
          {onBack &&
            labelBack &&
            (typeof onBack !== "string" ? (
              <button
                disabled={disableBack}
                onClick={handleBack}
                className={variantSecondaryClasses[variantSecondary || "secondary"]}
              >
                {labelBack}
              </button>
            ) : (
              <Link
                to={!disableBack ? (onBack as string) : "#"}
                className={twMerge(
                  variantSecondaryClasses[variantSecondary || "secondary"],
                  disableBack && "pointer-events-none disabled",
                )}
              >
                {labelBack}
              </Link>
            ))}

          {onNext &&
            labelNext &&
            (typeof onNext !== "string" ? (
              <button
                disabled={disableNext}
                onClick={handleNext}
                className={variantPrimaryClasses[variantPrimary || "primary"]}
              >
                {labelNext}
              </button>
            ) : (
              <Link
                to={!disableNext ? (onNext as string) : "#"}
                className={twMerge(
                  variantPrimaryClasses[variantPrimary || "primary"],
                  disableNext && "pointer-events-none disabled",
                )}
              >
                {labelNext}
              </Link>
            ))}
        </div>
      )}
    </div>
  )
}
export default memo(BottomBarDesktop)
